import http from "../http";
import ApiConstants from '../constants/ApiConstants';

class ShiftManagementService {
    static API_CONFIG = {
        currentPage: 1,
        limit: 20
    }

    static SHIFT = null;
    static IS_SHIFT_VIEW = false;
    static SELECTED_SHIFT_USER_ID = null;

    static getDefaultApiConfig() {
        return {
            currentPage: 1,
            limit: 20
        }
    }

    static addShift(payload) {
        const URL = `${ApiConstants.URL.BASE}${ApiConstants.URL.SHIFTS.ADD}`;
        return http.post(URL, payload).catch(
            (error) => {
                console.error('Error saving shift: ', error);
                return Promise.reject(error);
            }
        );
    }

    static getShifts(fetchPaginatedData) {
        const URL = `${ApiConstants.URL.BASE}${ApiConstants.URL.SHIFTS.GET}`;
        const params = {
            "orderBy.field": "updatedAt",
            "orderBy.order": "desc"
        };

        if (fetchPaginatedData) {
            params["currentPage"] = ShiftManagementService.API_CONFIG.currentPage;
            params["limit"] = ShiftManagementService.API_CONFIG.limit;
        }

        return http.get(URL, { params: params }).catch(
            (error) => {
                console.error('Error fetching shifts: ', error);
                return Promise.reject(error);
            }
        );
    }

    static getShiftById(shiftId) {
        const URL = `${ApiConstants.URL.BASE}${ApiConstants.URL.SHIFTS.GET}/${shiftId}`;
        return http.get(URL).catch(
            (error) => {
                console.error('Error fetching shift: ', error);
                return Promise.reject(error);
            }
        );
    }

    static updateShift(payload) {
        const URL = `${ApiConstants.URL.BASE}${ApiConstants.URL.SHIFTS.UPDATE}`;
        return http.patch(URL, payload).catch(
            (error) => {
                console.error('Error updating shift: ', error);
                return Promise.reject(error);
            }
        );
    }

    static deleteShift(ids) {
        const URL = `${ApiConstants.URL.BASE}${ApiConstants.URL.SHIFTS.DELETE}`;
        const params = {
            ids: ids
        };

        return http.post(URL, params).catch(
            (error) => {
                console.error('Error deleting shifts: ', error);
                return Promise.reject(error);
            }
        );
    }
}

export default ShiftManagementService;
